import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type fullScreen from './fullScreen.vue'

export const fullScreenProps = buildProps({} as const)

export type FullScreenProps = ExtractPropTypes<typeof fullScreenProps>
export type FullScreenInstance = InstanceType<typeof fullScreen>
